import { render, staticRenderFns } from "./ParentAccount.vue?vue&type=template&id=367f2e08&"
import script from "./ParentAccount.vue?vue&type=script&lang=js&"
export * from "./ParentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports